import React from "react";
import MainLayout from "../../common/MainLayout";
import { Box, CssBaseline } from "@mui/material";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import QuickTalesContainer from "../../modules/OrganizationQuickTales/containers/QuickTalesContainer/QuickTalesContainer";
import QuickTalesContributorsContainer from "../../modules/Contributors/containers/QuickTalesContributorContainer/QuickTalesContributorsContainer";

const Contributors = () => {
  return (
    <QuickTalesContributorsContainer />

    // <Box sx={{ display: "flex" }}>
    //   <CssBaseline />
    //   <Header mainTitle={"Contributors"} />
    //   <Sidebar />
    //   <MainLayout>
    //     {/* <h1>Contributors</h1> */}
    //   </MainLayout>
    // </Box>
  );
};

export default Contributors;
